import { component } from 'picoapp'

export default component((node, ctx) => {
  const menuToggle = node.querySelector('.js-menu-toggle')
  const menuItems = node.querySelectorAll('.main-menu__link')
  const logoLink = node.querySelector('.logo')

  // Create sticky menu 
  let sticky = document.createElement('div');
  let logo = node.querySelector('.logo').cloneNode(true);
  let menu = node.querySelector('.main-menu__items').cloneNode(true);
  let miniMenu = node.querySelector('.mini-menu--right').cloneNode(true);
  sticky.classList.add('sticky-menu');
  sticky.appendChild(logo);
  sticky.appendChild(menu);
  sticky.appendChild(miniMenu);
  node.appendChild(sticky);

  const cartToggles = node.querySelectorAll('.js-cart-drawer-toggle')
  const cartCounts = node.querySelectorAll('.js-cart-count')
  const searchToggle = node.querySelector('.site-header__btn--search')
  const searchStickyToggle = node.querySelector('.sticky-menu .site-header__btn--search')
  const searchField = node.querySelector('.main-menu__search-input')

  let applyCartToggle = function(toggle) {
    toggle.addEventListener('click', e => {
      e.preventDefault()
      ctx.emit('toggle_menu', { menuOpen: false });

      ctx.emit('cart:toggle', state => {
        return {
          cartOpen: !state.cartOpen
        }
      })
    })
  };

  let updateCartCount = function( state ) {
    for (let i = 0; i < cartCounts.length; i++) {
      cartCounts[i].innerHTML = state.cart.item_count
    }
  };

  for (let i = 0; i < cartToggles.length; i++) {
    applyCartToggle(cartToggles[i]);
  }

  ctx.on('cart:updated', state => {
    updateCartCount(state);
  })

  updateCartCount(ctx.getState());

  logoLink.addEventListener('click', e => {
    ctx.emit('toggle_menu', { menuOpen: false });
  });

  ctx.on('toggle_menu', state => {
  
    if (state.menuOpen) {
        node.classList.add('menu-visible');
        node.classList.add('menu-active');
    } else {
      node.classList.remove('menu-visible');
        setTimeout(() => {
          node.classList.remove('menu-active');
        }, 300);
    }
  })

  menuToggle.addEventListener('click', e => {
    e.preventDefault()
    ctx.emit('toggle_menu', { menuOpen: !ctx.getState().menuOpen });
  });


  // Mobile Menu accordions
  const menuTopLevelLinks = document.querySelectorAll('.main-menu__link');

  function isMobile() {
    const headerMobileBreakpoint = 900;
    const isMobile = window.innerWidth < headerMobileBreakpoint;

    return isMobile;
  }

  function topLevelMenuLinkClicked(e) {
    const link = e.currentTarget;
    const sublinks = link.nextElementSibling;

    if (isMobile() && sublinks) {
      e.preventDefault();
      sublinks.classList.toggle('is-open');
    }
  }
  
  for (let i = 0; i < menuTopLevelLinks.length; i++) {
    menuTopLevelLinks[i].addEventListener('click', topLevelMenuLinkClicked);
  }
  
  for (let i = 0; i < menuItems.length; i++) {
    menuItems[i].addEventListener('click', e => {
      // if (isMobile()) {
      //   return;
      // }
      // setTimeout(() => {
      //   ctx.emit('toggle_menu', { menuOpen: false });
      // }, 100);
    })
  }

  ctx.on('toggle_search', state => {
  
    if (state.searchOpen) {
        node.classList.add('search-visible');
        node.classList.add('search-active');
        searchField.focus();
    } else {
      node.classList.remove('search-visible');
        setTimeout(() => {
          node.classList.remove('search-active');
        }, 300);
    }
  })

  searchToggle.addEventListener('click', e => {
    e.preventDefault();
    ctx.emit('toggle_search', { searchOpen: !ctx.getState().searchOpen })
  });

  searchStickyToggle.addEventListener('click', e => {
    e.preventDefault();
    ctx.emit('toggle_search', { searchOpen: true })
  });

  /*searchField.addEventListener('blur', e => {
    e.preventDefault();
    setTimeout(() => {
      ctx.emit('toggle_search', { searchOpen: false })
    }, 200);
  })*/


})
